// extracted by mini-css-extract-plugin
export default {"manufacturer-report-container":"manufacturer_manufacturer-report-container__ZoGWJ"};